import { create } from 'zustand'
import { persist } from 'zustand/middleware'

export interface Session {
  service: string
  handle: string
  did: string
  accessJwt: string
  refreshJwt: string
}

interface State {
  session: Session | null
  setSession: (s: Session | null) => void
  patchTokens: (t: { accessJwt: string; refreshJwt: string }) => void
}

export const useSession = create<State>()(
  persist(
    (set) => ({
      session: null,
      setSession: (s) => set({ session: s }),
      patchTokens: (t) =>
        set((cur) =>
          cur.session ? { session: { ...cur.session, ...t } } : cur,
        ),
    }),
    { name: 'skypanel:session', version: 1 },
  ),
)
